import { render, staticRenderFns } from "./wddz.vue?vue&type=template&id=9da6307a&scoped=true&"
import script from "./wddz.vue?vue&type=script&lang=js&"
export * from "./wddz.vue?vue&type=script&lang=js&"
import style0 from "./wddz.vue?vue&type=style&index=0&id=9da6307a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da6307a",
  null
  
)

export default component.exports